<template>
  <div>
    <v-container fluid>
      <div v-for="(event, i) in events" :key="i" dense>
        <BoxLinkDirettaCard
          :url="event.externalRequestUrl"
          :code="event.code"
          :title="event.titolo"
          :hex-color="event.hexColor"
          :ora-evento="event.oraEvento"
          :content-id="event.contentId"
          class="mt-1"
        />
      </div>
    </v-container>
  </div>
</template>

<script>
import BoxLinkDirettaCard from './BoxLinkDirettaCard.vue'

export default {
  name: 'BoxLinkDiretta',
  components: {
    BoxLinkDirettaCard,
  },
  data: () => ({
    userId: 0,
    userCF: '',
    codes: [],
    events: [],
    resp: [],
  }),
  computed: {},
  mounted() {
    this.userId = localStorage.getItem('UserID')

    Promise.all([
      this.apiService.usersApi.getUserFiscalCode(this.userId),
      this.apiService.reservedAreaParticipantApi.getLiveLink(),
    ]).then(values => {
      this.userCF = values[0]
      this.events = values[1].map(x => ({
        code: x.codiceProdotto,
        externalRequestUrl: '',
        titolo: x.titolo,
        hexColor: x.hexColor,
        oraEvento: x.oraEvento,
        contentId: x.idContenuto,
      }))

      this.events.forEach(event => {
        let baseUrl = window.websiteConfig.sftpEdulifeUrl
        event.externalRequestUrl = `${baseUrl}/ws/GetLinkAccessoAulaVirtuale.aspx?edizione=${event.code}&cf=${this.userCF}`
        // event.externalRequestUrl = `https://elearning.euroconference.it/ws/GetLinkAccessoAulaVirtuale.aspx?edizione=${event.code}&cf=${this.userCF}`
        // event.externalRequestUrl = `http://formazioneeuroconference.edulife.eu/ws/GetLinkAccessoAulaVirtuale.aspx?edizione=${event.code}&cf=${this.userCF}`
        // event.externalRequestUrl = `http://formazioneeuroconference.edulife.eu/ws/GetLinkAccessoAulaVirtuale.aspx?edizione=020221WEBTSSEM13&cf=RBNRGB84D69E512M`
      })
    })
  },
  methods: {},
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
*,
:after,
:before {
  box-sizing: border-box;
}

.button {
  background: rgb(0, 158, 220);
}
a {
  background: rgb(0, 158, 220);
}
.display-flex {
  display: flex;
  align-items: baseline;
}
.filter-element {
  padding-left: 1rem;
}
.field-padding {
  padding-right: 20px;
}
.container {
  width: 100% !important;
}
</style>
<style>
.hidden-row {
  visibility: hidden !important;
}
.dx-texteditor-input {
  margin: 0 !important;
  background-color: transparent !important;
  /* color: rgba(0, 0, 0, 0.87) !important; */
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  -webkit-appearance: none !important;
  outline: 0 !important;
  border: 0 !important;
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
  user-select: text !important;
}
.v-container {
  padding: 0;
}
</style>
